var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form-item',{ref:"patientName",attrs:{"prop":"patientName"}},[_c('el-input',_vm._g(_vm._b({attrs:{"value":_vm.value,"placeholder":"Nombre"}},'el-input',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }